import axios from "axios";

const getUserByEmail = async (token, email) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/users`;

  try {
    const response = await axios.get(path, {
      headers: {
        Authorization: "Bearer " + token,
      },
      params: {
        email: email,
      },
    });
    // console.log(response);
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  } 
};

export default getUserByEmail;